export function App() {
  return (
    <div className="site">
      <div className="neon-bg" aria-hidden="true">
        <div className="orb orb-pink" />
        <div className="orb orb-purple" />
        <div className="orb orb-gold" />
      </div>

      <header className="hero">
        <p className="hero-kicker">Grand Junction's exclusive</p>
        <h1 className="hero-logo">Fantasy</h1>
        <p className="hero-sub">Gentlemen's Club</p>
        <div className="hero-badges">
          <span className="badge badge-live">Open 7 nights</span>
          <span className="badge">Happy hour 7–9 PM</span>
          <span className="badge">21+</span>
        </div>
        <div className="hero-actions">
          <a className="btn btn-primary" href="tel:9702428008">
            Call (970) 242-8008
          </a>
          <a
            className="btn btn-ghost"
            href="https://maps.google.com/?q=2258+Colex+Dr,+Grand+Junction,+CO+81505"
            target="_blank"
            rel="noreferrer"
          >
            Get directions
          </a>
        </div>
      </header>

      <main>
        <section className="marquee" aria-hidden="true">
          <div className="marquee-track">
            {[0, 1].map((copy) => (
              <span key={copy} className="marquee-group">
                <span>Happy hour daily 7–9 PM</span>
                <i />
                <span>$3 wine · wells · domestic beers</span>
                <i />
                <span>Grand Junction's exclusive gentlemen's club</span>
                <i />
                <span>Open 'til 4 AM on weekends</span>
                <i />
              </span>
            ))}
          </div>
        </section>

        <section className="section features">
          <article className="feature-card">
            <div className="feature-media">
              <img src="/stripper2.jpg" alt="Inside Fantasy Gentlemen's Club" loading="lazy" />
            </div>
            <div className="feature-body">
              <h2>The Club</h2>
              <p>
                Grand Junction's exclusive gentlemen's club — an intimate room,
                great music, and the friendliest staff on the Western Slope.
              </p>
            </div>
          </article>

          <article className="feature-card">
            <div className="feature-media">
              <img src="/beer1.jpg" alt="Ice cold beers at happy hour" loading="lazy" />
            </div>
            <div className="feature-body">
              <h2>Happy Hour</h2>
              <p className="feature-price">
                <span>$3.00</span>
              </p>
              <p>Daily 7–9 PM · wine, wells &amp; domestic beers.</p>
            </div>
          </article>

          <a
            className="feature-card feature-card-link"
            href="https://maps.google.com/?q=2258+Colex+Dr,+Grand+Junction,+CO+81505"
            target="_blank"
            rel="noreferrer"
            aria-label="Open Fantasy Gentlemen's Club in Google Maps"
          >
            <div className="feature-media">
              <img src="/map.png" alt="Map to Fantasy Gentlemen's Club" loading="lazy" />
            </div>
            <div className="feature-body">
              <h2>Find Us</h2>
              <p>Behind the Ford dealership, east of the Acorn truck stop.</p>
              <span className="feature-cta">Open in Google Maps →</span>
            </div>
          </a>
        </section>

        <section className="section split">
          <div className="panel">
            <h2 className="panel-title">Hours</h2>
            <dl className="hours">
              <div>
                <dt>Sun – Thu</dt>
                <dd>7 PM – 2 AM</dd>
              </div>
              <div>
                <dt>Fri – Sat</dt>
                <dd>7 PM – 4 AM</dd>
              </div>
            </dl>
            <p className="panel-note">Doors open at 7 PM, seven nights a week.</p>
          </div>

          <div className="panel">
            <h2 className="panel-title">Visit</h2>
            <address className="address">
              2258 Colex Dr
              <br />
              Grand Junction, CO 81505
            </address>
            <div className="panel-actions">
              <a className="btn btn-primary" href="tel:9702428008">
                (970) 242-8008
              </a>
              <a
                className="btn btn-ghost"
                href="https://maps.google.com/?q=2258+Colex+Dr,+Grand+Junction,+CO+81505"
                target="_blank"
                rel="noreferrer"
              >
                Open in Maps
              </a>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p className="footer-brand">Fantasy</p>
        <p>2258 Colex Dr · Grand Junction, CO · (970) 242-8008</p>
        <p className="footer-legal">Must be 21+ with valid ID · Please drink responsibly</p>
      </footer>
    </div>
  );
}
